import { useState, useEffect } from 'react';
import './header.scss';
import {
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,


} from 'reactstrap';

import brandlogo from '../../assets/images/header/logo.png';

import { Link, useNavigate, useParams } from 'react-router-dom';
import { io } from 'socket.io-client';


import { useToast } from '../../hook/usetoast';
import { useGetAirDropTimer, useUserStatusCheck } from '../../views/home/api/api';
import { useModalContext } from '../../contexts/ModalContext';
import Loader from '../../views/Loader/buttonLoad';
import ConnectWalletButton from './ConnectWallet/ConnectWallet';
import BuyTokenModal from '../../views/modals/buytoken';
import { useDisconnect } from '@reown/appkit-controllers/react';
import useAccountWatcher from '../../lib/watchAccount';
import { useAccount } from 'wagmi';


function Header() {
    // header scroll start
    const [buyTokenModal, setBuyTokenModal] = useState(false);

    const [scroll, setScroll] = useState(false);
    const { id } = useParams();


    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 50)
        })
    }, [])






    const toast = useToast()
    const navigate = useNavigate()
    const { address, isConnected } = useAccount();

    const { disconnect } = useDisconnect();



    const { isloadingconnect, setIsloadingconnect, userDetails, setUserDetails, isOpenMenu, setIsOpenMenu, referralCode, setReferralCode } = useModalContext()

    const checkLoggedIn = useUserStatusCheck()


    useEffect(() => {
        const role = sessionStorage.getItem("role");
        if (address === undefined && id === undefined && !isConnected && role !== 'adminView') {

            disconnect();
            localStorage.removeItem("account")
            sessionStorage.removeItem('user_JWT')
            navigate('/')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isConnected, address])

    const userData = useGetAirDropTimer()

    useEffect(() => {
        if (address) {
            getProfile()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sessionStorage.getItem('user_JWT')])

    const getProfile = async () => {
        if (sessionStorage.getItem('user_JWT')) {
            const res = await userData.mutateAsync()
            setUserDetails(res)
        }
    }

    useAccountWatcher(address, disconnect)





    useEffect(() => {
        if (!isConnected || isloadingconnect || referralCode) return
        const timeoutId = setTimeout(() => {
            checkLogout();
        }, 60000);

        return () => {
            clearTimeout(timeoutId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isConnected])
    const socket = io(process.env.REACT_APP_SOCKET_URL, {
        transports: ["polling"],
        polling: 10000,
    });

    socket.on('user-block-status', async (data) => {
        if (data.address === address.toLowerCase() && data.isBlocked === true) {
            localStorage.removeItem("account")
            localStorage.removeItem('memberId');
            sessionStorage.removeItem('user_JWT')
            sessionStorage.removeItem('connectAddress')
            disconnect();
        }
    })

    useEffect(() => {




        socket.on("check-activity", (payload) => {

            const connectedAddress = sessionStorage.getItem("connectAddress");

            if (!connectedAddress || payload?.data !== connectedAddress) {
                return;
            }

            if (payload.logOut === true || payload.status === false) {

                checkLogout()
                if (socket.connected) {
                    socket.disconnect();
                }

                return;
            }

            socket.emit("user-emit", {
                data: connectedAddress,
            });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (!sessionStorage.getItem('user_JWT') && isConnected && !referralCode) {

            (async () => {
                await checkLogout();

            })();
        }
        const role = sessionStorage.getItem("role");

        if (sessionStorage.getItem('user_JWT') && !isConnected && role !== 'adminView') {

            localStorage.removeItem("account")
            localStorage.removeItem('memberId');
            sessionStorage.removeItem('user_JWT')
            sessionStorage.removeItem('connectAddress')
            disconnect();

            navigate('/')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
        const role = sessionStorage.getItem("role");

        if (sessionStorage.getItem('user_JWT') && !isConnected && role !== 'adminView') {

            disconnect();

            localStorage.removeItem("account")
            localStorage.removeItem('memberId');
            sessionStorage.removeItem('user_JWT')
            sessionStorage.removeItem('connectAddress')
            navigate('/')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isConnected, sessionStorage.getItem('user_JWT')])



    const checkLogout = async () => {
        try {
            const checkStatus = await checkLoggedIn.mutateAsync({ address: address?.toLowerCase() })

            if (checkStatus?.status === true) {
                return;
            }

            await disconnect();

            setIsloadingconnect(true)
            setReferralCode(false)

            localStorage.removeItem("account")
            localStorage.removeItem('memberId');
            sessionStorage.removeItem('user_JWT')
            sessionStorage.removeItem('connectAddress')
            localStorage.removeItem('hasSeenFestivalOffer')
            navigate('/')
            setIsloadingconnect(false)
            setIsOpenMenu(!isOpenMenu)
            
        } catch (error) {
        }
    };
    useEffect(() => {
        let attempts = 0;
        const maxAttempts = 3;

        const interval = setInterval(async () => {
            const hasSession = sessionStorage.getItem("user_JWT");
            const hasAddress = sessionStorage.getItem("connectAddress");

            if (!hasSession && !hasAddress && isConnected) {

                await disconnect();

                Object.keys(localStorage).forEach((key) => {
                    if (key.startsWith("wagmi")) {
                        localStorage.removeItem(key);
                    }
                });

                localStorage.removeItem("account");
                localStorage.removeItem("memberId");
                sessionStorage.clear();

                navigate("/");

                attempts++;

                if (attempts >= maxAttempts) {
                    clearInterval(interval);
                }
            }
        }, 1000);

        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <>
            {isloadingconnect && <Loader />}
            <header className={scroll ? "navbgset" : ""}>
                <Navbar color="light" light expand="xl" className="mynavbar px-xl-0" fixed='top'>
                    <div className='container'>
                        <Link to="/">
                            <NavbarBrand >
                                <img src={brandlogo} className="logo" alt="brandlogo" />
                            </NavbarBrand>
                        </Link>
                        <NavbarToggler className='p-0' onClick={() => setIsOpenMenu(!isOpenMenu)}>
                            <div className={`smClose ${isOpenMenu ? 'active' : ""}`}>
                                <svg className='closeicon' viewBox="0 0 800 600">
                                    <path d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200" className='top'></path>
                                    <path d="M300,320 L460,320" className='middle'></path>
                                    <path d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190" className='bottom' transform="translate(480, 320) scale(1, -1) translate(-480, -318) "></path>
                                </svg>
                            </div>
                        </NavbarToggler>
                        <div className={`menucollapse ${isOpenMenu ? 'show' : ''}`}>
                            {!isConnected && sessionStorage.getItem('role') !== 'adminView' ?
                                <Nav className="mx-auto" navbar >
                                    <NavItem>
                                        <Link className='nav-link' to="/"><span>Home</span></Link>
                                    </NavItem>
                                    <NavItem>
                                        <Link className='nav-link' to="/"><span>Swap</span></Link>
                                    </NavItem>
                                    <NavItem>
                                        <Link className='nav-link' to="/"><span>Staking</span></Link>
                                    </NavItem>
                                    <NavItem>
                                        <Link className='nav-link' to="/whitepaper"><span>Whitepaper</span></Link>
                                    </NavItem>
                                </Nav>
                                :
                                <Nav className="ml-auto" navbar >

                                    <NavItem>
                                        <Link className={`nav-link ${sessionStorage.getItem("role") === 'adminView' ? "d-none" : ""}`} to={userDetails?.data?.commissionDistributeStatus ? '/dashboard' : ""}
                                            onClick={(e) => {
                                                if (!userDetails?.data?.commissionDistributeStatus && sessionStorage.getItem("user_JWT")) {
                                                    e.preventDefault();
                                                    toast.error('Need to deposit to access the dashboard.');
                                                }
                                                else if (!userDetails?.data?.isEmailVerified && sessionStorage.getItem("user_JWT")) {
                                                    e.preventDefault();
                                                    toast.error('Kindly verify your email to proceed with further actions');
                                                    navigate("/profile-details")
                                                }
                                            }}><span>Dashboard</span></Link>
                                    </NavItem>
                                    <NavItem>
                                        <Link className={`nav-link ${sessionStorage.getItem("role") === 'adminView' ? "d-none" : ""}`} to="#"
                                            onClick={(e) => {
                                                e.preventDefault(); // Prevent routing
                                                if (userDetails?.data?.commissionDistributeStatus && userDetails?.data?.isEmailVerified) {
                                                    setBuyTokenModal(!buyTokenModal);
                                                } else if (!userDetails?.data?.commissionDistributeStatus && sessionStorage.getItem("user_JWT")) {
                                                    e.preventDefault();
                                                    toast.error('Need to deposit to access the buyToken.');
                                                }
                                                else if (!userDetails?.data?.isEmailVerified) {
                                                    e.preventDefault();
                                                    toast.error('Kindly verify your email to proceed with further actions');
                                                    navigate("/profile-details")

                                                }
                                            }}><span>Buy Token</span></Link>
                                    </NavItem>
                                </Nav>
                            }
                            <ConnectWalletButton />




                        </div>
                    </div>
                </Navbar>
            </header>



            <BuyTokenModal modalOpen={buyTokenModal} modalClose={() => setBuyTokenModal(!buyTokenModal)} />

        </>
    );

}

export default Header;